/**
 * Client instrumentation hook (Next 15.3+). Runs once before the app
 * hydrates: initializes the error reporter, whose default integrations
 * register the global `window.onerror` / `unhandledrejection` handlers.
 * No-ops when NEXT_PUBLIC_SENTRY_DSN is unset.
 */

import * as Sentry from '@sentry/nextjs';
import { initTelemetry } from '@/lib/telemetry';

initTelemetry();

// Lets the SDK annotate captured errors with App Router navigation context.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
